export enum PrintFormat {
  A4 = <any>'A4',
  A3 = <any>'A3'
}
